import { defineMessages } from 'react-intl';

const messages = defineMessages({
  introTitle: {
    id: 'tabs-content.intro.title',
    defaultMessage: 'Use the menu on the left to manage the general introduction to your institution\'s Naviance college' +
        ' profile. The general introduction will override an opening statement, if one exists.',
  },
});

export default messages;
